import { useEffect, useState } from "react";

interface ProgressButtonProps {
    width?: string | number;
    text: string;
    textColor: string;
    primaryColor: string;
    secondaryColor: string;
    duration: number;
    onClick: () => void;
    onCompletion: () => void;
    endAdornmentIcon?: React.ReactNode;
}

export const ProgressButton: React.FC<ProgressButtonProps> = ({
    width = 'auto',
    text,
    textColor,
    primaryColor,
    secondaryColor,
    duration,
    onClick,
    onCompletion,
    endAdornmentIcon
}) => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setProgress(oldProgress => {
                if (oldProgress >= 100) {
                    clearInterval(interval);
                    onCompletion();
                    return 100;
                }
                return oldProgress + 1;
            });
        }, duration / 100);
        return () => clearInterval(interval);
    }, [duration, onCompletion]);

    return (
        <button
            onClick={onClick}
            className='flex items-center justify-center rounded'
            style={{
                width,
                height: "40px",
                padding: "10px 20px",
                background: `linear-gradient(to right, ${secondaryColor} ${progress}%, ${primaryColor} ${progress}%)`,
                color: textColor,
            }}
        >
            {text}
            {endAdornmentIcon && (
                <div className="ml-4 flex items-center justify-center pt-[1px]">
                    {endAdornmentIcon}
                </div>
            )}
        </button>
    );
};